/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 11/08/2020.
 * @module APP SAGA
 */

import { get } from "lodash";
import { call, put, takeLatest } from "redux-saga/effects";
import services from "services";
import {
  browseAllStations,
  browseOwnCompanyStations,
  browseOwnStations,
  browseRepositories,
  browseStationsV2,
  getAllHardWare,
  getAllMenu,
  getAllStation,
  getStrictedRoute,
  getUserStation
} from "./actions";

/**
 * Handler lấy danh sách kho
 */
const _handleBrowseRepositories = function*() {
  try {
    let response = yield call(services.WorkService.getListStation);

    const payload = {
      data: get(response, "data"),
      meta: {
        error: response.error,
        status: response.status,
        statusText: response.statusText
      }
    };
    if (response.success === true) {
      yield put(browseRepositories.success(payload));
    } else {
      yield put(browseRepositories.failure(payload));
    }
  } catch (error) {
    yield put(browseRepositories.failure());
  }
};

const _handleBrowseAllStations = function*() {
  try {
    let response = yield call(services.WorkService.getAllStation);

    const payload = {
      data: get(response, "data"),
      meta: {
        error: response.error,
        status: response.status,
        statusText: response.statusText
      }
    };
    if (response.success === true) {
      yield put(browseAllStations.success(payload));
    } else {
      yield put(browseAllStations.failure(payload));
    }
  } catch (error) {
    yield put(browseAllStations.failure());
  }
};

const _handleBrowseOwnStations = function*() {
  try {
    let response = yield call(services.WorkService.getOwnStation);

    const payload = {
      data: get(response, "data"),
      meta: {
        error: response.error,
        status: response.status,
        statusText: response.statusText
      }
    };
    if (response.success === true) {
      yield put(browseOwnStations.success(payload));
    } else {
      yield put(browseOwnStations.failure(payload));
    }
  } catch (error) {
    yield put(browseOwnStations.failure());
  }
};

const _handleBrowseOwnCompanyStations = function*() {
  try {
    let response = yield call(services.Tracker.getUserStation);
    response = response.data;
    const payload = {
      data: get(response, "data"),
      meta: {
        error: response.error,
        status: response.status,
        statusText: response.statusText
      }
    };
    if (response.success === true) {
      yield put(browseOwnCompanyStations.success(payload));
    } else {
      yield put(browseOwnCompanyStations.failure(payload));
    }
  } catch (error) {
    yield put(browseOwnCompanyStations.failure());
  }
};

const handleGetMenu = function*() {
  try {
    let response = yield call(services.AdmcsmService.getUserMenu);

    const payload = {
      data: get(response, "data.data"),
      meta: {
        error: response.error,
        status: response.status,
        statusText: response.statusText
      }
    };
    if (response.data.success === true) {
      yield put(getAllMenu.success(payload));
    } else {
      yield put(getAllMenu.failure(payload));
    }
  } catch (error) {
    yield put(getAllMenu.failure());
  }
};
const handleGetStrictedRoute = function*() {
  try {
    let response = yield call(services.AdmcsmService.getStrictedRoute);

    const payload = {
      data: get(response, "data.data"),
      meta: {
        error: response.error,
        status: response.status,
        statusText: response.statusText
      }
    };
    if (response.data.success === true) {
      yield put(getStrictedRoute.success(payload));
    } else {
      yield put(getStrictedRoute.failure(payload));
    }
  } catch (error) {
    yield put(getStrictedRoute.failure());
  }
};

const handleGetUserStation = function*() {
  try {
    let response = yield call(services.AdmcsmService.getUserStation);

    const payload = {
      data: get(response, "data.data"),
      meta: {
        error: response.error,
        status: response.status,
        statusText: response.statusText
      }
    };
    if (response.data.success === true) {
      // yield put(getUserStation.success(payload));
    } else {
      yield put(getUserStation.failure(payload));
    }
  } catch (error) {
    yield put(getUserStation.failure());
  }
};

// const handleGetUserStation = function*(action) {
//   try {
//     let response = yield call(services.Tracker.getUserStation);

//     const payload = {
//       data: get(response, "data.data"),
//       meta: {
//         error: response.error,
//         status: response.status,
//         statusText: response.statusText
//       }
//     };
//     if (response.data.success === true) {
//       // yield put(getUserStation.success(payload));
//     } else {
//       yield put(getUserStation.failure(payload));
//     }
//   } catch (error) {
//     yield put(getUserStation.failure());
//   }
// };
const handleGetAllStation = function*() {
  try {
    let response = yield call(services.AdmcsmService.getAllStation);

    const payload = {
      data: get(response, "data.data"),
      meta: {
        error: response.error,
        status: response.status,
        statusText: response.statusText
      }
    };
    if (response.data.success === true) {
      yield put(getAllStation.success(payload));
    } else {
      yield put(getAllStation.failure(payload));
    }
  } catch (error) {
    yield put(getAllStation.failure());
  }
};
// const handleGetAllStation = function*(action) {
//   try {
//     let response = yield call(services.Tracker.getUserStation);

//     const payload = {
//       data: get(response, "data.data"),
//       meta: {
//         error: response.error,
//         status: response.status,
//         statusText: response.statusText
//       }
//     };
//     if (response.data.success === true) {
//       yield put(getAllStation.success(payload));
//     } else {
//       yield put(getAllStation.failure(payload));
//     }
//   } catch (error) {
//     yield put(getAllStation.failure());
//   }
// };
const handleGetAllHardWare = function*() {
  try {
    let response = yield call(services.Tracker.getListHardwares);

    const payload = {
      data: get(response, "data.data"),
      meta: {
        error: response.error,
        status: response.status,
        statusText: response.statusText
      }
    };
    if (response.data.success === true) {
      yield put(getAllHardWare.success(payload));
    } else {
      yield put(getAllHardWare.failure(payload));
    }
  } catch (error) {
    yield put(getAllHardWare.failure());
  }
};

const _handleBrowseStationsV2 = function*() {
  try {
    let response = yield call(services.WorkService.getV2Station);

    const payload = {
      data: get(response, "data", []),
      meta: {
        error: response.error,
        status: response.status,
        statusText: response.statusText
      }
    };
    if (response.success === true) {
      yield put(browseStationsV2.success(payload));
    } else {
      yield put(browseStationsV2.failure(payload));
    }
  } catch (error) {
    yield put(browseStationsV2.failure());
  }
};

export default function* saga() {
  yield takeLatest(browseRepositories.TRIGGER, _handleBrowseRepositories);
  yield takeLatest(browseAllStations.TRIGGER, _handleBrowseAllStations);
  yield takeLatest(browseOwnStations.TRIGGER, _handleBrowseOwnStations);
  yield takeLatest(
    browseOwnCompanyStations.TRIGGER,
    _handleBrowseOwnCompanyStations
  );
  yield takeLatest(getAllMenu.TRIGGER, handleGetMenu);
  yield takeLatest(getStrictedRoute.TRIGGER, handleGetStrictedRoute);
  yield takeLatest(getAllStation.TRIGGER, handleGetAllStation);
  yield takeLatest(getUserStation.TRIGGER, handleGetUserStation);
  yield takeLatest(getAllHardWare.TRIGGER, handleGetAllHardWare);
  yield takeLatest(browseStationsV2.TRIGGER, _handleBrowseStationsV2);
}
